module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"User profile","lists_title":"Shared lists","try":"Try PackTrek"},"de":{"title":"Nutzerprofil","lists_title":"Geteilte Listen","try":"PackTrek ausprobieren"}}')
  delete Component.options._Ctor
}
